import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DecimalPlaceEnum } from 'src/app/domain/registration/enums/decimal-place.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { DynamicFormComponent } from 'src/app/shared/components/dynamic-form/containers/dynamic-form/dynamic-form.component';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { IEvents } from 'src/app/domain/registration/models/IEvents';
import { CES_CONFIG_FIELDS } from '../crud-config';

@Component({
  selector: 'app-faq-events-ces',
  templateUrl: './crud-ces.component.html',
  styleUrls: ['./crud-ces.component.sass'],
})
export class FaqCESComponent implements OnInit, OnDestroy {
  @ViewChild(DynamicFormComponent) form: DynamicFormComponent;
  config: IFieldConfig[] = CES_CONFIG_FIELDS;
  data: IEvents;
  type: TypeCesEnum;
  title = '--';
  subFormChanges: Subscription;

  get typeCesEnum() {
    return TypeCesEnum;
  }

  setFields() {
    // PADRÃO
    this.form.setDisabled('submit', true);
    this.form.setValue('id', this.data?.id);
    // NA CÓPIA ALTERA APENAS ESSES
    this.form.setValue('code', this.data?.id);
    this.form.setValue('description', this.data?.description);
  }

  constructor(
    public dialogRef: MatDialogRef<FaqCESComponent>,
    @Inject(MAT_DIALOG_DATA) data: { type: TypeCesEnum; element: IEvents },
    private cdr: ChangeDetectorRef
  ) {
    this.type = data.type;
    this.data = data.element;
    this.title = this.type;
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    let previousValid = this.form.valid;

    this.subFormChanges = this.form.changes.subscribe(() => {
      if (this.form.valid !== previousValid) {
        previousValid = this.form.valid;
        this.form.setDisabled('submit', !previousValid);
      }
    });

    this.setFields();
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.subFormChanges.unsubscribe();
  }

  onSubmit(value: { [name: string]: any }) {
    this.dialogRef.close({ element: value });
  }

  onCancel() {
    this.dialogRef.close();
  }

  changeType(type: TypeCesEnum) {
    this.type = type;
    this.dialogRef.close({ changeType: type });
  }

  delete() {
    this.dialogRef.close({ delete: true });
  }
}
